module.exports = __webpack_public_path__ + "img/converse-details3.984f3f53.png";